const config:any = {};

const productionAppDirectory = 'auth/';

const insideMode = window.location.pathname.indexOf('/platform/') === 0;

config.prodMode = process.env.NODE_ENV === 'production';
config.remoteMode = process.env.REMOTE;
const platformDirectory = insideMode ? '/platform' : '';

config.appPath = config.prodMode ? platformDirectory + '/apps/' + productionAppDirectory : '/';//Относительный путь к проекту
config.host = 'https://' + window.location.host + config.appPath;//Абсолютный путь к проекту
config.root = 'https://' + window.location.hostname + platformDirectory;//Абсолютный путь к корню платформы
config.apiHost = config.remoteMode ? 'https://backend.platform-amakids.eu/api/' : config.root + '/api/';//Абсолютный путь к разделу API
config.personalCabinet = config.root + '/apps/student/';//Абсолютный путь к ЛК

config.path = {
    login: {
        main: config.root,
        request: config.root + '?tab=request',
        demoAccess: config.appPath + 'demoAccess',
        removeAccountRequest: config.appPath + 'remove-account-request',
    }
};

export default config;